export default "__VITE_ASSET__646eb634__"